export const UPDATE_LOCATION_TITLE = 'UPDATE_LOCATION_TITLE';

type LocationTitle = string;

export const updateLocationTitle = (payload: LocationTitle) => ({
    type: UPDATE_LOCATION_TITLE,
    payload,
});

export default (state = '', action: { type: string; payload: LocationTitle }) =>
    action.type === UPDATE_LOCATION_TITLE ? action.payload || '' : state;
